<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">
    <div class="proj_id d-flex">
      <div class="title_sub_div_1 mt-1">Dashboard </div>
    </div>
    <div class="title_sub_div_1 title_right_icon_div mr-1">
      <i class="fa fa-refresh" (click)="refreshPage()" title="Refresh dashboard data" style="color: black;"></i>
    </div>
  </div>
</div>

<div class="d-flex justify-content-between">
  <div class="d-flex justify-content-start">

    <div class="form-group position-relative" title="Project Name" style="width: 150px;">
      <input id="projectName" class="form-control form-select-lg custom-dropdown-input" type="text"
        placeholder="Search Project Name" [(ngModel)]="selectedProjectName" (input)="filterProjectNames()"
        (focus)="showProjectDropdown = true" (blur)="hideDropdown()" autocomplete="off" />

      <ul class="list-group position-absolute project-dropdown"
        *ngIf="showProjectDropdown && filteredProjectNames.length > 0">
        <li class="list-group-item list-group-item-action project-dropdown-item"
          *ngFor="let name of filteredProjectNames" (mousedown)="selectProjectName(name)" [title]="name">
          {{ name }}
        </li>
      </ul>
    </div>


    <div class="form-group" title="Select Customer">
      <select id="customerName" class="form-control form-select-lg" aria-label="Select Customer Name"
        [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
        <option disabled value="" [selected]="selectedCustomerName === ''">Customer </option>
        <option *ngFor="let cus of allCustomerData" [value]="cus.customerName">{{ cus.customerName }}</option>
      </select>
    </div>
    <div class="form-group" title="Select Stage">
      <select id="customerName" class="form-control form-select-lg" aria-label="Select Stage"
        [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
        <option disabled value="" [selected]="selectedCurrentStage === ''">Select Stage</option>
        <option value="Costing" [selected]="selectedCurrentStage === 'Costing'">Costing</option>
        <option value="Procurement" [selected]="selectedCurrentStage === 'Procurement'">Procurement</option>
      </select>
    </div>

    <!-- Button to trigger the ECD modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalECD()">ECD Date</button>

    <!-- ECD Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
      [ngStyle]="{'display': showModalECD ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Expected Completion Date </h5>
            <button type="button" class="close" (click)="closeModalECD()">
              <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="Expected Completion Date">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromExpectedCompletionDate">From</label>

                  <input id="fromExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
                <div>
                  <label for="toExpectedCompletionDate">To</label>
                  <input id="toExpectedCompletionDate" class="custom-date" type="date"
                    aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                    (change)="onSelectCompletionDate()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalECD()">Close</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Button to trigger the RFQ modal -->
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      (click)="openModalRFQ()">RFQ Date
    </button>

    <!-- RFQ Date Range Modal Popup -->
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
      [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">RFQ Date</h5>
            <button type="button" class="close" (click)="closeModalRFQ()">
              <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group" title="RFQ Date Range">
              <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                <div>
                  <label for="fromRfqDate">From</label>
                  <input id="fromRfqDate" class="custom-date" type="date" aria-label="Select From RFQ Date"
                    [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
                </div>
                <div>
                  <label for="toRfqDate">To</label>
                  <input id="toRfqDate" class="custom-date" type="date" aria-label="Select To RFQ Date"
                    [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Reset Button -->
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="resetRfqDates()">Reset</button>
            <button type="button" class="btn btn-outline-primary btn-sm form-group"
              (click)="closeModalRFQ()">Close</button>
          </div>
        </div>

      </div>

    </div>
    <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
      title="Reset fields" (click)="resetFields()">Reset</button>
  </div>
  <div class="d-flex justify-content-end">
    <button type="button" class="btn btn-outline-primary btn-sm" title="SmartSync"
      (click)="onClickSmartSync()">SmartSync</button>
  </div>
</div>

<div class="d-flex justify-content-start">

  <div (click)="onOpenClickedProject('Open')">
    <div class="custom-card-small custom-card-open-projects" style="padding: 10px;">
      <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">

        <div class="text-block">
          <div class="custom-card-number-small">{{openStatusCount}}</div>
          <div class="custom-card-text-small">Open Projects</div>
        </div>

        <span class="fa fa-folder-open card-icon-right"></span>

      </div>
    </div>
  </div>


  <div (click)="onOverdueClick()">
    <div class="custom-card-small custom-card-overdue" style="padding: 10px;">
      <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
        <div class="text-block">
          <div class="custom-card-number-small">{{overdueCount}}</div>
          <div class="custom-card-text-small">Over Due</div>
        </div>
        <span class="fa fa-clock card-icon-right"></span>

      </div>
    </div>
  </div>
  <div (click)="onThisMonthClick()">
    <div class="custom-card-small custom-card-yet-to-approved" style="padding: 10px;">
      <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
        <div class="text-block">
          <div class="custom-card-number-small">{{ thisMonthProjects?.length || 0 }}</div>
          <div class="custom-card-text-small">This Month</div>
        </div>
      </div>
      <span class="fa fa-calendar card-icon-right"></span>
    </div>
  </div>

  <div>
    <div class="custom-card-small custom-card-high-risk-parts" style="padding: 10px;">
      <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
        <div class="text-block">
          <div class="custom-card-number-small">10</div>
          <div class="custom-card-text-small">High Risk Parts</div>
        </div>
      </div>
      <span class="fa fa-exclamation-triangle card-icon-right" style="color: black;"></span>
    </div>
  </div>
</div>




<div *ngIf="loading" class="row row_mar mt-1 w-100">
  <div class="card w-100">
    <div class="card-body">
      Loading data...
    </div>
  </div>
</div>

<!-- Show "No data found" only if not loading and no data -->
<div *ngIf="!loading && matchedCustomerData.length === 0" class="row row_mar mt-1 w-100">
  <div class="card w-100">
    <div class="card-body">
      No data found.
    </div>
  </div>
</div>
<div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-body">

        <!-- Pagination Controls -->
        <div class="pagination-controls">
          <!-- Left: Rows per page -->
          <div>
            <label for="rowsPerPage">Show:</label>
            <select id="rowsPerPage" class="rows-per-page" [(ngModel)]="rowsPerPage" (change)="updateTableRows()">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
            rows
          </div>

          <!-- Right: Pagination Navigation with Row Count -->
          <div class="d-flex align-items-center">
            <span class="row-count">Showing {{ startIndex }} to {{ endIndex }} of {{ matchedCustomerData.length }}
              rows</span>
            <button class="pagination-btn addBtn me-1" (click)="previousPage()"
              [disabled]="currentPage === 1">‹</button>
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="pagination-btn addBtn ms-1" (click)="nextPage()"
              [disabled]="currentPage === totalPages">›</button>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Project Name</th>
                <th>Customer Name</th>
                <th>RFQ Date</th>
                <th>Assigned Date</th>
                <th>E.C.Date</th>
                <th class="text-center">Target L.Time(W)</th>
                <th class="text-center">Ageing</th>
                <th>Progress</th>
                <th>Status</th>
                <th>Upload Status</th>
                <th>Current Stage</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let customer of paginatedData; let i = index; trackBy: trackByCustomer">
                <td (click)="onRowSelect(customer)">{{ ((currentPage - 1) * (rowsPerPage === 'All' ?
                  matchedCustomerData.length : rowsPerPage)) + i + 1 }}</td>
                <td (click)="onRowSelect(customer)" title="{{ customer?.projectName }}">{{ customer?.projectName }}</td>
                <td (click)="onRowSelect(customer)" title="{{ customer?.customer_name }}">{{ customer?.customer_name }}
                </td>
                <td (click)="onRowSelect(customer)" class="td_date"
                  title="{{ customer?.rfqDate | date: 'dd-MM-yyyy' }}">{{ customer?.rfqDate | date: 'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(customer)" class="td_date"
                  title="{{ customer?.assigned_date | date: 'dd-MM-yyyy' }}">{{ customer?.assigned_date | date:
                  'dd-MM-yyyy' }}</td>
                <td (click)="onRowSelect(customer)" class="td_date"
                  title="{{ customer?.expectedCompletionDate | date: 'dd-MM-yyyy' }}">{{
                  customer?.expectedCompletionDate | date: 'dd-MM-yyyy' }}</td>
                <td class="text-center" (click)="onRowSelect(customer)" title="{{ customer?.targetLeadTime }}">{{
                  customer?.targetLeadTime
                  }}</td>
                <td class="text-center" (click)="onRowSelect(customer)"
                  [title]="calculateAgeing(customer?.assigned_date, customer?.status, customer?.closed_date)"
                  [ngStyle]="{'color': (customer.status === 'Open' && isECDGreaterThanToday(customer.expectedCompletionDate)) ? 'red' : 'inherit'}">
                  {{ calculateAgeing(customer?.assigned_date, customer?.status, customer?.closed_date) }}
                </td>

                <td>
                  <div class="progress-container" (click)="onRowSelect(customer)">
                    <div
                      style="width: 80%; height: 14px; background-color: #f5f5f5; position: relative; border-radius: 10px; overflow: hidden;">

                      <!-- Progress text -->
                      <div
                        style="position: absolute; z-index: 10; width: 100%; text-align: center; font-size: 12px; color: #000;   margin-top: -2px;">
                        {{ customer.progress }}
                      </div>

                      <!-- Progress bar -->
                      <div [ngStyle]="{
          'width': customer.progress,
          'height': '100%',
          'background-color': '#86c5d8',
          'border-radius': '10px'
        }">
                      </div>

                    </div>
                  </div>
                </td>

                <td>
                  <span [ngStyle]="{
    'color': (customer.status === 'Open') ? '#FFA500' : 
             (customer.status === 'Closed') ? '#e23328' : 'inherit'
  }">
                    {{ customer.status }}
                  </span>
                </td>

                <td *ngIf="!customer.newVersion">
                  <ng-container
                    *ngIf="customer.upload_status?.toLowerCase() === 'error' || customer.upload_status?.toLowerCase() === 'new'; else statusText">
                    <button type="button" class="btn btn-primary btn-sm ml-1 addBtn" title="Add Sourcing List"
                      (click)="uploadSourcingList(uploadFileModal, customer)">
                      +
                    </button>
                  </ng-container>

                  <ng-template #statusText>
                    <span class="text-muted" title="{{customer.upload_status}}">
                      {{ customer.upload_status === 'NoPartsFound' ? 'Completed' : customer.upload_status }}
                    </span>
                  </ng-template>

                </td>

                <td *ngIf="customer.newVersion" (click)="onRowSelect(customer)" title="{{customer.newVersion}}">In
                  Progress </td>

                <td (click)="onRowSelect(customer)" title="{{customer?.currentstage}}">
                  <span [ngStyle]="{
    'color': customer.currentstage === 'Costing' ? '#1e90ff' : 
              customer.currentstage === 'Procurement' ? '#ff4500' : 'inherit'
  }">
                    {{ customer?.currentstage }}
                  </span>
                </td>


                <td>
                  <div class="d-flex align-items-center">
                    <ng-container *ngIf="!customer.isAddingNewVersion">
                      <select class="form-select form-select-sm version-dropdown" [(ngModel)]="customer.version_id"
                        (change)="onVersionChange(customer)" [disabled]="isLowerVersion(customer)"
                        title="Version number">
                        <option value="" disabled selected>Version</option>
                        <option *ngFor="let version_id of customer.version_ids" [value]="version_id">
                          {{ version_id }}
                        </option>
                      </select>


                      <button type="button" class="btn btn-sm btn-primary addBtn ms-1"
                        (click)="startAddingNewVersion(customer)" title="Add new version number">
                        +
                      </button>


                    </ng-container>
                    <ng-container *ngIf="customer.isAddingNewVersion">
                      <input type="number" class="form-control form-control-sm version-dropdown"
                        [(ngModel)]="customer.newVersion" readonly />
                      <button type="button" class="btn btn-sm btn-primary addBtn"
                        (click)="saveNewVersion(customer)">✔</button>
                      <button type="button" class="btn btn-sm btn-danger"
                        (click)="cancelNewVersion(customer)">✖</button>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="sourceListData.length > 0 || avdData.length > 0">
  <div *ngIf="matchedCustomerData.length > 0">
    <div class="row row_mar mt-1" *ngIf="finalDataList.length === 0">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Sourcing List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th>Customer Part Number</th>
                    <th>Internal Part Number</th>
                    <th>Description</th>
                    <th>Specification</th>
                    <th>Commodity</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>UOM</th>
                    <th>Project Quantity</th>
                    <th>I-Sourcing</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of sourceListData">
                    <td>{{ item.SlNo }}</td>
                    <td>{{ item.customerPartNumber }}</td>
                    <td>{{ item.internalPartNo }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.specification }}</td>
                    <td>{{ item.commodity }}</td>
                    <td>{{ item.manufacturer }}</td>
                    <td>{{ item.uom }}</td>
                    <td>{{ item.projectQty }}</td>
                    <td>{{ item.iSourcing }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="finalDataList.length === 0" class="row row_mar mt-1">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0">Alternate Vendor List Details</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Internal Part No.</th>
                    <th>Manufacturer(Mfg)</th>
                    <th>Specification</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let avditem of avdData">
                    <td>{{ avditem.internalPartNo }}</td>
                    <td>{{ avditem.manufacturer }}</td>
                    <td>{{ avditem.specification }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="finalDataList.length > 0" class="row row_mar">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <h6 class="card-title">Preview</h6>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-light btn-sm" title="Export as Excel" (click)="exportData()">
            <i class="fas fa-file-export"></i> Export
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="resetFinalData()">Reset</button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="selectCriteria(criteriaModal)">Criteria</button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="Data(dataPrefModal)">Data Preferece</button>

          <button type="button" class="btn btn-outline-primary btn-sm" title="Upload data" [disabled]="!isUploadEnabled"
            (click)="uploadFinalData()">
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Upload
          </button>
        </div>
      </div>



      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">

          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th *ngFor="let col of tableHeaders; let i = index">
                  {{ col.label }}
                  <i class="fa fa-chevron-down" (click)="toggleSearch(i)"></i> <!-- Font Awesome Icon -->
                </th>
              </tr>
              <tr *ngIf="showSearch">
                <th *ngFor="let col of tableHeaders; let i = index">
                  <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                    [(ngModel)]="searchValues[i]" (input)="filterData(searchValues[i])"
                    placeholder="Search {{ col.label }}" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of finalDataList; let i=index">
                <td>{{ i+1 }}</td>
                <td>{{ item?.customerPartNumber }}</td>
                <td>{{ item?.internalPartNo }}</td>
                <td>{{ item?.description }}</td>
                <td>{{ item?.specification }}</td>
                <td>{{ item?.commodity }}</td>
                <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i)">

                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]"
                      class="form-select form-select-sm manufacturer-dropdown drop-7rem"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td>
                <td>{{ item?.uom }}</td>
                <td>{{ item?.projectQty }}</td>
                <td>{{ item?.iSourcing }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #customerModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Customer</h6>
  </div>
  <div>
    <div class="row">
      <div class="column">
        <label for="firstName">Customer FullName</label>
        <input type="text" id="customerFullName" placeholder="Enter Full Name">
      </div>
      <div class="column">
        <label for="lastName">City</label>
        <input type="text" id="city" placeholder="Enter City">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="state">State</label>
        <input type="text" id="state" placeholder="Enter State">
      </div>
      <div class="column">
        <label for="zip">Country</label>
        <input type="text" id="country" placeholder="Enter Country">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="state">GST Number</label>
        <input type="text" id="gstNumber" placeholder="Enter GST Number">
      </div>
      <div class="column">

      </div>
    </div>
    <!-- </div> -->

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveCustomer()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #projectModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Project</h6>
  </div>
  <div>

    <div class="row">
      <div class="column">
        <label for="firstName">New Project Name</label>
        <input type="text" id="newProjectName" placeholder="New Project Name">
      </div>
      <div class="column">
        <label for="lastName">Customer Name</label>
        <input type="text" id="lastName" placeholder="Customer Name">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="email">RFQ Date</label>
        <input type="date" id="rfqData" placeholder="RFQ Date">
      </div>
      <div class="column">
        <label for="phone">Expected Completion Date</label>
        <input type="date" id="expectedCompletionDate" placeholder="Expected Completion Date">
      </div>
    </div>
    <div class="row">
      <div class="column">
        <label for="address">Target L. T</label>
        <input type="text" id="targetLT" placeholder="Target L. T">
      </div>
      <div class="column">
        <label for="city"></label>
        <button type="button" class="btn btn-primary btn-sm ml-1" title="Landing Cost"
          (click)="onLandinCost(landinCostModal)">Landing Cost</button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="save()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #landinCostModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Landing Cost</h6>
  </div>
  <div class="modal-body">
    <!-- Q1 -->
    <div class="form-group">
      <label>
        Q-1: Do you want to calculate Landing cost for the project?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q1Yes" checked name="q1" (click)="onQn1Change('yes')">
        <label class="form-check-label" for="q1Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q1No" name="q1" (click)="onQn1Change('no')">
        <label class="form-check-label" for="q1No">No</label>
      </div>
    </div>

    <!-- Q2 -->
    <div class="form-group" *ngIf="showQn2">
      <label>
        Q-2: Do you want to consider Duties for calculating landing cost?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q2Yes" name="q2" (click)="onQn2Change('yes')">
        <label class="form-check-label" for="q2Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q2No" name="q2" (click)="onQn2Change('no')">
        <label class="form-check-label" for="q2No">No</label>
      </div>
    </div>

    <!-- Q3 -->
    <div class="form-group" *ngIf="showQn3">
      <label>
        Q-3: Is it for Export or for local consumption?
      </label>
      <select class="form-select form-select-lg" (change)="onQn3Change($event.target.value)">
        <option value="">Select</option>
        <option value="export">Export</option>
        <option value="local">Local Consumption</option>
      </select>
    </div>

    <!-- Q4 -->
    <div class="form-group" *ngIf="showQn4">
      <label>
        Q-4: Do you need specific duty to be added?
      </label>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q4Yes" name="q4" (click)="onQn4Change('yes')">
        <label class="form-check-label" for="q4Yes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="q4No" name="q4" (click)="onQn4Change('no')">
        <label class="form-check-label" for="q4No">No</label>
      </div>
    </div>

    <!-- Q5 -->
    <div class="form-group" *ngIf="showQn5">
      <label>
        Q-5: Define your generic duty percentage to be considered
      </label>
      <input type="number" class="form-control" placeholder="Enter generic duty percentage">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveLandingCost()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<ng-template #uploadFileModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Upload Files</h6>
  </div>
  <div *ngIf="headerErrorMessage" style="color: red; font-weight: bold; margin-left: 20px;">
    {{ headerErrorMessage }}
    <button type="button" *ngIf="isHeaderMappingRequired && sourceListData.length > 0"
      class="btn btn-outline-primary btn-sm mt-2" [disabled]="!sourcingListFileName"
      (click)="openHeaderMappingModal(mappingModal)" title="Open mapping popup">
      Configure
    </button>
  </div>


  <div class="modal-body">
    <div class="main-div flex-wrap">
      <div class="form-group modalformGroup">
        <label class="upladed_label_field" (click)="sourcingData()"
          title="Download Sample Sourcing List to upload file">
          Sample Sourcing List
          <nb-icon icon="download-outline" class="icon-download" (click)="sourcingData()" style="margin-right: 8px;"
            title="Download Sample Excel file for Sourcing List"></nb-icon>
        </label>
        <div class="form-group input-group upladed_data_field">
          <input type="text" class="form-control" placeholder="Upload sourcing file" [value]="sourcingListFileName"
            readonly (click)="upload_input.click()" title="Upload sourcing file">
          <input #upload_input type="file" class="file-input" hidden (change)="uploadSourcingListFiles($event)">

        </div>
        <button type="button" *ngIf="sourceListData.length > 0" class="btn btn-outline-primary btn-sm mt-2"
          [disabled]="!sourcingListFileName" (click)="clearSourcingListFiles()" title="Clear sourcing file">
          Clear
        </button>


      </div>

      <ng-template #mappingModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title"> Please Map The Required Fields</h5>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div *ngIf="uploadedHeaders.length > 0">
            <div *ngFor="let field of tableHeaders" class="form-group row align-items-center mb-2">
              <label class="col-md-4 font-weight-bold">{{ field.label }}</label>
              <div class="col-md-8">
                <select class="form-control" [(ngModel)]="reverseFieldMapping[field.key]" name="{{field.key}}">
                  <option [ngValue]="null">-- Select Column from Upload --</option>
                  <option *ngFor="let header of uploadedHeaders" [value]="header">
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="modal.dismiss()">Cancel</button>
          <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="applyMappedData(); modal.close()">
            Apply Mapping</button>
        </div>
      </ng-template>

      <div class="form-group modalformGroup mt-1">
        <label class="upladed_label_field" (click)="alternateData()"
          title="Download Sample Alternate Vendor List to upload file">

          Sample Alternate Vendor List
          <nb-icon icon="download-outline" class="icon-download" (click)="alternateData()" style="margin-right: 8px;"
            title="Download Sample excel file for Alternate Part List"></nb-icon>
        </label>

        <div class="form-group input-group upladed_data_field">
          <input type="text" class="form-control" placeholder="Upload AVD file" [value]="alternatePartFileName" readonly
            (click)="upload_file_input.click()" title="Upload PDF or Excel file">

          <input #upload_file_input type="file" accept=".pdf,.xlsx" class="file-input" hidden
            (change)="handleFileUpload($event)">
        </div>

        <button type="button" *ngIf="avdData.length > 0" class="btn btn-outline-primary btn-sm mt-2"
          [disabled]="!alternatePartFileName" [disabled]="avdData.length === 0" (click)="clearAvdFiles()"
          title="Clear alternate file">
          Clear
        </button>


      </div>


    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="finalData()"
      [disabled]="isLoading">
      Compare Both File
    </button>

    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeUploadModal()">
      Close
    </button>
  </div>
</ng-template>



<ng-template #criteriaModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Criteria</h6>
  </div>
  <div class="modal-body">
    <div class="main-div flex-wrap">
      <div class="form-group modalformGroup">
        <label>
          <input type="checkbox" [(ngModel)]="criteria.stockAvailability" />
          Stock Availability
        </label>
      </div>

      <div class="form-group modalformGroup">
        <label>
          <input type="checkbox" [(ngModel)]="criteria.leadTime" />
          Lead Time
        </label>
      </div>

      <div class="form-group modalformGroup">
        <label>
          <input type="checkbox" [(ngModel)]="criteria.minimumPrice" />
          Minimum Price
        </label>
      </div>
      <div class="form-group modalformGroup">
        <label>
          <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" />
          Authorised suppliers
        </label>
      </div>
      <div class="custom-supplier-container">
        <label for="supplierSelection" class="custom-supplier-label">Supplier Selection:</label>
        <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" [multiple]="true" bindLabel="name"
          bindValue="name" class="custom-supplier-ng-select">
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="custom-supplier-selected">{{ item.name }}</span>
            <i class="mdi mdi-close-circle-outline custom-supplier-clear-icon" (click)="clear($event)"></i>
          </ng-template>
        </ng-select>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Save" (click)="saveModal()">
      Save
    </button>
    <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">
      Close
    </button>
  </div>
</ng-template>

<!-- Modal for Uploading -->
<div class="modal fade show d-block" *ngIf="isUploading" id="uploadModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content text-center p-4">
      <div class="modal-body">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <!-- <h6 class="mt-3">Data Uploading, Please wait...</h6> -->
        <h6 class="mt-3">Sourcing in progress, please wait...</h6>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop (optional) -->
<div class="modal-backdrop fade show" *ngIf="isUploading"></div>


<!-- Transparent Modal with Loading Spinner -->
<div class="modal fade show d-block transparent-modal" *ngIf="isRefresh" id="uploadModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border-0 bg-transparent text-center">
      <div class="modal-body">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show"></div>

<ng-template #dataPrefModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Select Data Preference</h5>

  </div>

  <div class="modal-body">
    <div class="d-flex align-items-center gap-2">

      <div class="form-check form-switch me-2">
        <input class="form-check-input" type="checkbox" id="nexarSwitch" name="dataPref"
          [checked]="dataPreference.includes('nexar')" (change)="onDataPrefChange('nexar', $event.target.checked)">
        <label class="form-check-label ms-1" for="nexarSwitch"> Consolidator</label>
      </div>

      <div class="form-check form-switch" style="margin: 10px;">
        <input class="form-check-input" type="checkbox" id="vendorDataSwitch" name="dataPref"
          [checked]="dataPreference.includes('vendor')" (change)="onDataPrefChange('vendor', $event.target.checked)">
        <label class="form-check-label ms-1" for="vendorDataSwitch">Direct</label>
      </div>

    </div>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-outline-primary btn-sm" (click)="saveDataPreference()">Save</button>
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>